var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pc-age-and-sex"},[_c('div',{staticStyle:{"height":"400px","width":"50%"},attrs:{"id":"age"}}),_vm._v(" "),_c('div',{staticStyle:{"height":"400px","width":"50%"},attrs:{"id":"sex"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15ed5f83","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/userManagement/userList/AgeAndSex.vue
// module id = JBj5
// module chunks = 0